import get from 'lodash.get';
import React from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';

import Logo from 'src/components/Logo';

import './style.scss';

export const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

type BusinessProfileModalProps = {
  show: boolean;
  onHide: () => void;
  business: EntityFields;
  onSelect?: () => void;
};

const BusinessProfileModal: React.FunctionComponent<BusinessProfileModalProps> = ({
  business,
  show,
  onHide,
  onSelect,
}) => {
  if (!business) {
    return null;
  }

  const {
    address,
    emailAddress,
    website,
    externalLinks,
    phoneNumber,
    logo,
    name,
    businessOpeningHoursInfo,
    businessHourNotes,
    openNow,
  } = business;

  const getUrl = (url: string) => (url.includes('http') ? url : `//${url}`);

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <strong>Business Profile Details</strong>
      </Modal.Header>
      <Modal.Body className="small">
        <div className="d-flex flex-column align-items-center mb-3">
          <div>
            <Logo imageSrc={logo} text={name} height={50} width={50} variant="rounded-circle" />
          </div>
          <span className="text-muted mt-1 font-size-14">{name}</span>
        </div>
        <Row className="mx-0">
          <Col md={3} className="d-flex flex-column justify-content-between px-0">
            <strong className="pb-2">Address</strong>
          </Col>
          <Col md={9} className="d-flex flex-column justify-content-between px-0">
            <span className="pb-2">{`${address.address1}, ${address.address2 || ''} ${address.city}, ${
              address.state
            }, ${address.zipCode}`}</span>
          </Col>
        </Row>
        <Row className="mx-0">
          <Col md={3} className="d-flex flex-column justify-content-between px-0">
            <strong className="py-2">Phone Number</strong>
          </Col>
          <Col md={9} className="d-flex flex-column justify-content-between px-0">
            {(phoneNumber || []).map((p, index) => (
              <span className={`${!index ? 'pt-2 pb-2' : 'pb-2'}`} key={`phoneNumber-${index}`}>
                {p}
              </span>
            ))}
          </Col>
        </Row>
        <Row className="mx-0">
          <Col md={3} className="d-flex flex-column justify-content-between px-0">
            <strong className="py-2">Email Address</strong>
          </Col>
          <Col md={9} className="d-flex flex-column justify-content-between px-0">
            <span className="py-2">
              {emailAddress ? (
                <a href={`mailto:${emailAddress}`} target="_blank" rel="noopener noreferrer">
                  {emailAddress}
                </a>
              ) : null}
            </span>
          </Col>
        </Row>
        <Row className="mx-0">
          <Col md={3} className="d-flex flex-column justify-content-between px-0">
            <strong className="py-2">Website</strong>
          </Col>
          <Col md={9} className="d-flex flex-column justify-content-between px-0">
            <a href={getUrl(website)} target="_blank" rel="noopener noreferrer" className="py-2">
              <span className="text-primary">{website}</span>
            </a>
          </Col>
        </Row>
        <Row className="mx-0">
          <Col md={3} className="d-flex flex-column justify-content-between px-0">
            <strong className="py-2">External Links</strong>
          </Col>
          <Col md={9} className="d-flex flex-column justify-content-between px-0">
            {(externalLinks || []).map((e, index) => (
              <a
                key={`link-${index}`}
                href={getUrl(e)}
                target="_blank"
                rel="noopener noreferrer"
                className={`${!index ? 'pt-2 pb-2' : 'pb-2'} text-primary`}
              >
                <span>{e}</span>
              </a>
            ))}
          </Col>
        </Row>
        {businessHourNotes || (businessOpeningHoursInfo && businessOpeningHoursInfo.length) ? (
          <>
            <Row className="mx-0">
              <Col md={3} className="d-flex flex-column justify-content-between px-0">
                <strong className="py-2">Business Hours</strong>
              </Col>
              <Col md={9} className="d-flex flex-column justify-content-between px-0">
                {get(openNow, 'isOpen') ? (
                  <span className="py-2">
                    <span className="open-now">Open Now</span> - {get(openNow, 'timings')}
                  </span>
                ) : null}
              </Col>
            </Row>
            <div className="border rounded bg-light p-2">
              {businessOpeningHoursInfo &&
                businessOpeningHoursInfo.map(businessHour => (
                  <Row className="mx-0" key={businessHour.day}>
                    <Col md={3} className="d-flex flex-column justify-content-between px-0">
                      {/* @ts-ignore */}
                      <span className="pb-1">{days[parseInt(businessHour.day, 10) - 1]}</span>
                    </Col>
                    <Col md={9} className="d-flex flex-column justify-content-between px-0">
                      <span className="pb-1">
                        {businessHour.startTime} - {businessHour.endTime}
                      </span>
                    </Col>
                  </Row>
                ))}
              {businessHourNotes ? (
                <div>
                  <div className="py-1">
                    <strong>Notes</strong>
                  </div>
                  <div className="pb-1">{businessHourNotes}</div>
                </div>
              ) : null}
            </div>
          </>
        ) : null}
        <div className="d-flex justify-content-center">
          <Button className="mt-3" onClick={onSelect}>
            <small>Continue with this business profile</small>
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BusinessProfileModal;
